import { render, staticRenderFns } from "./PageBuilder.vue?vue&type=template&id=94598f88"
import script from "./PageBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBuilder.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports